import * as _ from 'lodash';
import toastr from 'toastr';
import ApiService from '../../../../service/apiService';
import logUtils from '../../../../HelperMethods/LogUtils';
import * as Utility from '../../../../HelperMethods/UtilityFunctions';
import { getUsersApi } from '../../../../HelperMethods/apiHelper';
import {
  loadWatcherGroups as loadWatcherGroupsInRedux,
  setFormLoader,
  setLoader,
  upsertWatcherGroup,
  deleteWatcherGroup as deleteWatcherGroupFromRedux,
} from './reducer';

export function loadWatcherGroups(fieldId) {
  return async (dispatch) => {
    dispatch(setLoader(true));
    try {
      const response = await ApiService.bulkDownloadWatcherGroups(fieldId);
      const successResponse = _.get(response, 'data.rpcService.success');
      if (!successResponse) {
        throw response;
      }
      const watchergroups =
        _.get(response, 'data.rpcService.output') && JSON.parse(_.get(response, 'data.rpcService.output'));
      if (watchergroups) {
        dispatch(loadWatcherGroupsInRedux(watchergroups));
      } else {
        throw new Error('Watcher Groups not found in api');
      }
    } catch (e) {
      dispatch(loadWatcherGroupsInRedux([]));
      logUtils.logError(e, 'Loading Watchergroups Failed');
    } finally {
      dispatch(setLoader(false));
    }
  };
}

export function updateWatcherGroup(watchergroup) {
  return async (dispatch) => {
    dispatch(setFormLoader(true));
    try {
      const response = await ApiService.upsertWatchergroup(watchergroup);
      const success = _.get(response, 'data.rpcService.success');
      if (!success) {
        throw response;
      }
      const updatedWatchergroup =
        _.get(response, 'data.rpcService.output') && JSON.parse(_.get(response, 'data.rpcService.output'));
      if (!updatedWatchergroup) throw new Error('Error in update api');
      toastr.success('Watcher group updated');
      dispatch(upsertWatcherGroup(updatedWatchergroup));
    } catch (e) {
      logUtils.logError(e, 'Updating Watcher group failed');
      throw e;
    } finally {
      dispatch(setFormLoader(false));
    }
  };
}

export function createWatcherGroup(watchergroup) {
  return async (dispatch) => {
    dispatch(setFormLoader(true));
    try {
      delete watchergroup.id;
      const response = await ApiService.upsertWatchergroup(watchergroup);
      const success = _.get(response, 'data.rpcService.success');
      if (!success) {
        throw response;
      }
      const createdWatchergroup =
        _.get(response, 'data.rpcService.output') && JSON.parse(_.get(response, 'data.rpcService.output'));
      if (!createdWatchergroup) throw new Error('Watcher group not created');
      toastr.success('Watcher group Created');
      dispatch(upsertWatcherGroup(createdWatchergroup));
    } catch (e) {
      logUtils.logError(e, 'Watcher group creation failed');
      throw e;
    } finally {
      dispatch(setFormLoader(false));
    }
  };
}

export function onSubmitButtonClicked(watchergroup) {
  return async (dispatch) => {
    const clonedWatchergroup = _.clone(watchergroup);
    if (!clonedWatchergroup.xid) {
      clonedWatchergroup.xid = clonedWatchergroup.name;
    }
    if (clonedWatchergroup.id) {
      await updateWatcherGroup(clonedWatchergroup)(dispatch);
    } else {
      await createWatcherGroup(clonedWatchergroup)(dispatch);
    }
  };
}

export function deleteWatchergroup(watchergroup) {
  return async (dispatch) => {
    dispatch(setLoader(true));
    const clonedWatchergroup = _.clone(watchergroup);
    clonedWatchergroup.isDeleted = true;
    try {
      const response = await ApiService.upsertWatchergroup(clonedWatchergroup);
      const success = _.get(response, 'data.rpcService.success');
      if (!success) {
        throw response;
      }
      dispatch(deleteWatcherGroupFromRedux(watchergroup));
      toastr.success('Watcher group Deleted');
    } catch (e) {
      logUtils.logError(e, 'Watcher group  deleting failed');
    } finally {
      dispatch(setLoader(false));
    }
  };
}

export async function getAllUsers(apiFunction, ...apiArgs) {
  let nextToken = null;
  let totalCount = 0;
  const userList = [];
  do {
    const response = await apiFunction(...apiArgs, nextToken);
    const users = _.get(response, `data.searchUsers.items`) || [];
    userList.push(...users);
    nextToken = response.data.searchUsers.nextToken;
    totalCount = parseInt(_.get(response, `data.searchUsers.total`, 0));
  } while (nextToken && nextToken < totalCount);
  return userList;
}

export function loadUsersForField(fieldId) {
  const params = Utility.getSearchGraphQLParamForFieldId(fieldId);
  return async () => {
    try {
      const res = await getAllUsers(getUsersApi, params);
      return res;
    } catch (e) {
      logUtils.logError(e, 'Users Loading Failed');
      return [];
    }
  };
}
